import { OrderDirectionEnum } from '@eih-netbroker/api-order';

export const TradeType = OrderDirectionEnum;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type TradeType = (typeof TradeType)[keyof typeof TradeType];
